import styled from "styled-components";
import { StyledGlobalMainContainer } from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  margin: 140px auto;
  @media (max-width: 768px) {
    padding: 0 22px;
    padding-bottom: 42px;
  }
  @media (max-width: 768px) {
    margin: 50px 0;
  }
`;

export const StyledTitleContainer = styled.div`
  display: grid;
  justify-items: center;
  grid-row-gap: 23px;
`;

export const StyledMainContainer = styled.div`
  margin-top: 58px;
  display: grid;
  grid-gap: 10px;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(275px, auto));
`;

export const StyledInnerContainer = styled.div`
  margin-top: 45px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  grid-gap: 45px;
  align-items: start;
  //@media(max-width: 1440px){
  //  grid-template-columns: 1fr 1fr ;
  //}
  @media(max-width: 500px) {
    grid-template-columns: repeat(auto-fit, minmax(320px, auto));
  }
`;
